import React, { useState, useEffect } from "react";
import { Column, TotalItem, Summary, GroupItem, Grouping } from "devextreme-react/data-grid";
import { PaginaListado } from "../../Componentes/Compuestos/Paginas/PaginaListado";
import { LVGridCabeceraReporte } from "../../Componentes/Basicos/LVGridCabeceraReporte";

export const STK_ART_Merma = () => {
  const [data, setData] = useState([])
  const [globalUsaArticulosConPresentacion, setGlobalUsaArticulosConPresentacion] = useState([])
  const [globalUsaArticulosConTamano, setGlobalUsaArticulosConTamano] = useState([])
  const [globalUsaArticulosConUnidadDeMedida, setGlobalUsaArticulosConUnidadDeMedida] = useState([])
  const { Varios: { ObtieneParametros,
    TratamientoDeVariableBoolean } } = require('neftis7_apicaller');
  const { STK_ART_Merma: { function_STK_ART_Merma_Listar } } = require('neftis7_apicaller');

  const handleDataLoaded = (data) => {
    setData(data);
  };

  const getDataParametros = async () => {
    // Llama a función asíncrona y maneja los datos
    try {
      const datosModificadores = await ObtieneParametros();
      const globalUsaArticulosConPresentacionLocal = await TratamientoDeVariableBoolean(datosModificadores.GlobalUsaArticulosConPresentacion)
      const globalUsaArticulosConTamanoLocal = await TratamientoDeVariableBoolean(datosModificadores.GlobalUsaArticulosConTamano)
      const globalUsaArticulosConUnidadDeMedidaLocal = await TratamientoDeVariableBoolean(datosModificadores.GlobalUsaArticulosConUnidadDeMedida)

      setGlobalUsaArticulosConPresentacion(globalUsaArticulosConPresentacionLocal)
      setGlobalUsaArticulosConTamano(globalUsaArticulosConTamanoLocal)
      setGlobalUsaArticulosConUnidadDeMedida(globalUsaArticulosConUnidadDeMedidaLocal)

    } catch (error) {
      alert("Error al obtener los datos: " + error);
    }
  };

  useEffect(() => {
    getDataParametros();
  }, []);

  return (
    <PaginaListado
      Titulo="MERMA"
      funcion={function_STK_ART_Merma_Listar}
      onDataLoaded={handleDataLoaded}
    >
      <div className="table-responsive">
        {data.length > 0 ? (
          <LVGridCabeceraReporte
            dataSource={data}
            id="gridContainer"
            keyExpr="CodigoArticulo"
          >
            <Grouping autoExpandAll={true} />
            <Summary>
              <TotalItem
                column="CodigoArticulo"
                summaryType="count"
                customizeText={summaryItem => `Registros: ${summaryItem.value}`} />

              <GroupItem
                column="CodigoArticulo"
                summaryType="count"

                displayFormat="Registros: {0} "
                showInGroupFooter={true} />
              <GroupItem
                column="Cantidad"
                summaryType="sum"
                customizeText={summaryItem => `${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="number"
                showInGroupFooter={true} />
            </Summary>

            <Column caption="Código" dataField="IdItem" width="120" alignment="Right" dataType="number" />
            <Column caption="Fecha" dataField="Fecha" width="100" alignment="Right" dataType="date" format={'dd/MM/yyyy'} filterOperations={['between']} />

            <Column caption="Artículo" alignment="Center">
              <Column caption="Código" dataField="CodigoArticulo" width="120" alignment="Left" dataType="string" />
              <Column caption="Descripción" dataField="Articulo" width="100%" minWidth={200} alignment="Left" dataType="string" />
            </Column>
            <Column caption="Presentación" alignment="Center" visible={globalUsaArticulosConPresentacion}>
              <Column caption="Código" dataField="CodigoPresentacion" width="100" alignment="Left" dataType="string" visible={globalUsaArticulosConPresentacion} />
              <Column caption="Descripción" dataField="Presentacion" width="200" alignment="Left" dataType="string" visible={globalUsaArticulosConPresentacion} />
            </Column>
            <Column caption="Tamaño" alignment="Center" visible={globalUsaArticulosConTamano} >
              <Column caption="Código" dataField="CodigoTamano" width="100" alignment="Left" dataType="string" visible={globalUsaArticulosConTamano} />
              <Column caption="Descripción" dataField="Tamano" width="250" alignment="Left" dataType="string" visible={globalUsaArticulosConTamano} />
            </Column>

            <Column caption="Unidad de Medida" alignment="Center" visible={globalUsaArticulosConUnidadDeMedida} >
              <Column caption="Código" dataField="CodigoUnidadMedida" width="100" alignment="Left" dataType="string" visible={globalUsaArticulosConUnidadDeMedida} />
              <Column caption="Descripción" dataField="UnidadMedida" width="250" alignment="Left" dataType="string" visible={globalUsaArticulosConUnidadDeMedida} />
            </Column>
            <Column caption="Ubicación" alignment="Center" visible={globalUsaArticulosConUnidadDeMedida} >
              <Column caption="Código" dataField="CodigoUbicacion" width="100" alignment="Left" dataType="string" visible={globalUsaArticulosConUnidadDeMedida} />
              <Column caption="Descripción" dataField="Ubicacion" width="200" alignment="Left" dataType="string" visible={globalUsaArticulosConUnidadDeMedida} />
            </Column>

            <Column caption="Cantidad" dataField="Cantidad" width="100" alignment="Right" dataType="number" />
            <Column caption="Terminal" dataField="Terminal" width="100" alignment="Right" dataType="number" />
            <Column caption="Observaciones" dataField="Observaciones" width="200" alignment="Left" dataType="string" />
            <Column caption="Responsable" dataField="PersonaResponsable" width="200" alignment="Left" dataType="string" />

          </LVGridCabeceraReporte>
        ) : (
          <div className="card-body text-center">
            <h5 className="card-title">No hay datos</h5>
          </div>
        )}
      </div>
    </PaginaListado>
  );
};
